import { BaseEntity } from '../base-entity';
import { OrganisationWorkspace } from './organisation-workspace';
import { PbiDeployment } from './pbi-deployment';
import { WorkspaceDeploymentFailure } from './workspace-deployment-failure';

/// <code-import> Place custom imports between <code-import> tags
import { AuthzContextsActionMap } from '@mri-platform/resource-authz';

/// </code-import>

export interface OrganisationWorkspaceDeployment {
  id: string;
  createdDate: Date;
  datasetDeploymentId?: string;
  deployStateUpdatedOn: Date;
  lastUpdatedBy: string;
  lastUpdatedDate: Date;
  organisationWorkspaceId: string;
  pbiDeploymentId: string;
  periodEnd: Date;
  periodStart: Date;
  revertedToId?: string;
  rolledBackId?: string;
  status: string;
  tenantKey: string;
  datasetDeployment: OrganisationWorkspaceDeployment;
  failures: WorkspaceDeploymentFailure[];
  organisationWorkspace: OrganisationWorkspace;
  pbiDeployment: PbiDeployment;
  revertedTo: OrganisationWorkspaceDeployment;
  rolledBack: OrganisationWorkspaceDeployment;
}

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class OrganisationWorkspaceDeployment extends BaseEntity {
  /// <code> Place custom code between <code> tags
  static readonly authorization: AuthzContextsActionMap = AuthzContextsActionMap.crudFor(
    'OrganisationWorkspaceDeployment'
  );
  /// </code>
  // Generated code. Do not place code below this line.
}
